<script setup>
import { computed } from 'vue';

const emit = defineEmits(['update:checked']);

const props = defineProps({
  checked: {
    type: [Array, Boolean],
    required: true,
  },
  value: {
    default: null,
  },
  name: String,
});

const proxyChecked = computed({
  get() {
    return props.checked;
  },

  set(val) {
    emit('update:checked', val);
  },
});
</script>

<template>
  <input
    type="checkbox"
    :value="value"
    v-model="proxyChecked"
    class="border border-grey-300 rounded shadow dark:border-grey-600 text-main dark:text-main-light focus:ring-primary dark:focus:ring-primary dark:bg-grey-700"
    :name="name"
  />
</template>
